module.exports = __webpack_public_path__ + "static/media/wn_23.2185cb5a.jpg";